import { initialState, initialAvailailityFactory } from './scheduling.state'
import types from './scheduling.types'
import _get from 'lodash/get'

export default {
  [types.RESET_STATE]: (state) => {
    Object.assign(state, {
      ...initialState(),
    })
  },
  [types.UPDATE_SELECTED_DOCTORS]: (
    state,
    { doctor, isDelete, canSelectMultiple }
  ) => {
    if (isDelete) {
      state.selectedDoctors = state.selectedDoctors.filter(
        (selectedDoctor) => selectedDoctor.id !== doctor.id
      )
      return
    }

    const existingDoctorIndex = state.selectedDoctors.findIndex(
      (selectedDoctor) => selectedDoctor.id === doctor.id
    )

    if (!canSelectMultiple) {
      state.selectedDoctors = [doctor]
      return
    }

    if (existingDoctorIndex === -1) {
      state.selectedDoctors.push(doctor)
    } else {
      state.selectedDoctors.splice(existingDoctorIndex, 1, doctor)
    }
  },
  [types.REMOVE_SELECTED_DOCTOR]: (state, doctor) => {
    state.selectedDoctors = state.selectedDoctors.filter(
      (selectedDoctor) => selectedDoctor.id !== doctor.id
    )
  },
  [types.UPDATE_PREFERENCE_ORDER]: (
    state,
    { newPreferenceValue, oldPreferenceValue }
  ) => {
    const temp = state.selectedDoctors[oldPreferenceValue]
    state.selectedDoctors.splice(oldPreferenceValue, 1)
    state.selectedDoctors.splice(newPreferenceValue, 0, temp)
  },
  [types.SET_DOCTOR_PREFERENCES]: (state, doctorPreferences) => {
    state.doctorPreferences = {
      ...state.doctorPreferences,
      ...doctorPreferences,
    }
  },
  [types.SELECT_AVAILABILITY]: (state, { day, time, checked }) => {
    state.selectedAvailability[day][time] = checked
  },
  [types.SET_HAS_PERSONAL_DOCTOR_ON_FILE]: (state, hasPersonalDoctorOnFile) => {
    state.hasPersonalDoctorOnFile = hasPersonalDoctorOnFile
  },
  [types.SET_HEALTH_PLAN_REQUIRES_PERSONAL_DOCTOR]: (
    state,
    healthPlanRequiresPersonalDoctor
  ) => {
    state.healthPlanRequiresPersonalDoctor = healthPlanRequiresPersonalDoctor
  },
  [types.RESET_AVAILABILITY]: (state) => {
    state.selectedAvailability = initialAvailailityFactory()
  },
  [types.RESET_DOCTOR]: (state) => {
    state.selectedDoctors = []
  },
  [types.KEEP_ONLY_FIRST_DOCTOR]: (state) => {
    if (state.selectedDoctors.length > 1) {
      const firstDoctor = state.selectedDoctors[0]
      state.selectedDoctors = firstDoctor ? [firstDoctor] : []
    }
  },
  [types.SET_RECOMMENDED_DOCTORS]: (state, recommendedDoctors) => {
    state.recommendedDoctors = recommendedDoctors.map(mapProvider)
  },
  [types.SET_ZIP_CODE]: (state, zipCode) => {
    state.zipCode = zipCode
  },
  [types.SET_IS_FETCHING_PROVIDERS]: (state, isFetchingProviders) => {
    state.isFetchingProviders = isFetchingProviders
  },
  [types.SET_PCPS_ON_FILE]: (state, pcpsOnFile) => {
    state.pcpsOnFile = pcpsOnFile.map(mapProvider)
  },
  [types.SET_IS_FETCHING_PCPS_ON_FILE]: (state, isFetchingPcpsOnFile) => {
    state.isFetchingPcpsOnFile = isFetchingPcpsOnFile
  },
  [types.SET_SCHEDULED_APPOINTMENT]: (state, scheduledAppointment) => {
    state.scheduledAppointment = scheduledAppointment
  },
  [types.SET_IS_FETCHING_SCHEDULED_APPOINTMENT]: (
    state,
    isFetchingScheduledAppointment
  ) => {
    state.isFetchingScheduledAppointment = isFetchingScheduledAppointment
  },
  [types.SET_DEMO_PHONE_OVERRIDE]: (state, demoPhoneOverride) => {
    state.demoPhoneOverride = demoPhoneOverride
  },
}

function mapProvider(doctor) {
  function getClinicName() {
    const primaryLocation = _get(doctor, 'phoneNumbers', []).find(
      (phoneNumber) => phoneNumber.details === 'primary'
    )
    if (doctor.hospital) {
      return doctor.hospital
    }
    if (primaryLocation && primaryLocation.name) {
      return primaryLocation.name
    }
    return undefined
  }

  function getProviderName() {
    let providerName = doctor.firstName
    if (doctor.middleName) {
      providerName += ' ' + doctor.middleName.slice(0, 1) + '.'
    }
    providerName += ' ' + doctor.lastName
    if (doctor.degrees && doctor.degrees.length > 0) {
      providerName += ', ' + doctor.degrees.slice(0, 1)
    }
    return providerName
  }

  return {
    id: doctor.npi,
    scheduleKey: doctor.scheduleKey,
    name: getProviderName(doctor),
    gender: doctor.gender,
    clinic: getClinicName(doctor),
    address: doctor.address,
    phone: doctor.phoneNumber,
    distance: doctor.distance,
  }
}
